{
  "verse": {
    "loading": "آیت لوڈ ہو رہی ہے...",
    "error": "آیت لوڈ نہیں ہو سکی",
    "reference": "— سورہ {{surah}}، آیت {{ayah}}",
    "arabicUnavailable": "(عربی دستیاب نہیں)",
    "english": "انگریزی",
    "arabic": "العربية",
    "swapLanguage_aria": "زبان بدلیں",
    "toggleLanguage_title": "انگریزی / عربی تبدیل کریں",
    "reflect": "تدبر کریں",
    "reflecting": "سوچ رہا ہے…",
    "reflect_aria": "اس آیت کو آپ کی نیت سے جوڑتا ایک ذاتی تدبر تیار کریں",
    "insights": "بصیرت",
    "insights_aria": "AI قرآنی بصیرت کھولیں",
    "share": "شیئر کریں",
    "share_aria": "اس آیت کو تصویر کے طور پر شیئر کریں",
    "share_title": "اس آیت کو شیئر کریں",
    "removeFromFavorites_aria": "پسندیدہ سے ہٹائیں",
    "saveToFavorites_aria": "پسندیدہ میں محفوظ کریں",
    "favoritesProLocked_aria": "پسندیدہ ایک Pro خصوصیت ہے",
    "favoritesUpgrade_aria": "پسندیدہ محفوظ کرنے کے لیے اپ گریڈ کریں",
    "signInToSave": "پسندیدہ محفوظ کرنے کے لیے سائن اِن کریں۔",
    "failedToUpdateFavorites": "پسندیدہ اپ ڈیٹ نہیں ہو سکیں",
    "couldNotReflect": "تدبر تیار نہیں ہو سکا",
    "shareCaption": "\"{{text}}\"\n— سورہ {{surah}}، آیت {{ayah}}\n\nrhemn.com",
    "imageSavedVerseCopied": "تصویر محفوظ · آیت کاپی ہو گئی",
    "imageSaved": "آیت کی تصویر محفوظ ہو گئی",
    "couldNotCreateImage": "تصویر نہیں بن سکی"
  },
  "insights": {
    "panel_aria": "قرآنی بصیرت پینل",
    "title": "بصیرت",
    "reference": "سورہ {{surah}}، آیت {{ayah}}",
    "close_aria": "بصیرت پینل بند کریں",
    "versePreview_aria": "آیت کا جائزہ",
    "back_aria": "واپس",
    "tryAgain": "دوبارہ کوشش کریں",
    "backTo_aria": "{{ref}} پر واپس جائیں",
    "copyVerse_aria": "{{ref}} کاپی کریں",
    "openingVerse": "آیت کھولی جا رہی ہے…",
    "verseError": "آیت نہیں کھل سکی۔"
  },
  "proGate": {
    "title": "AI قرآنی بصیرت ایک Pro خصوصیت ہے",
    "subtitleSafari": "Unlock deep, contextual understanding of every verse with Rhemn Pro. Already a member? It unlocks automatically when you sign in.",
    "subtitle": "ہر آیت کی گہری، سیاق و سباق پر مبنی سمجھ حاصل کریں۔",
    "bulletAsk": "آیت کے بارے میں کوئی بھی سوال پوچھیں",
    "bulletTafsir": "فوری AI سے تیار کردہ تفسیر خلاصے",
    "bulletRelated": "موضوعاتی طور پر متعلقہ آیات دریافت کریں",
    "upgrade": "Pro میں اپ گریڈ کریں"
  },
  "ask": {
    "heading": "پوچھیں",
    "suggestion1": "اس آیت کا وسیع تر سیاق و سباق کیا ہے؟",
    "suggestion2": "میں اسے روزمرہ زندگی میں کیسے اپنا سکتا ہوں؟",
    "suggestion3": "کلاسیکی علما اس بارے میں کیا کہتے ہیں؟",
    "placeholder": "اس آیت کے بارے میں کچھ بھی پوچھیں…",
    "input_aria": "اس آیت کے بارے میں کوئی سوال پوچھیں",
    "submit_aria": "سوال جمع کریں",
    "submit_title": "جمع کریں (⌘↵)",
    "submit_label": "پوچھیں",
    "submit_hint": "⌘↵",
    "suggestions_aria": "تجویز کردہ سوالات",
    "error": "جواب حاصل نہیں ہو سکا۔",
    "pending": "آپ کے سوال پر غور کیا جا رہا ہے…",
    "attribution": "AI سے تیار کردہ جواب · مستند علمی رہنمائی کا بدل نہیں"
  },
  "tafsir": {
    "heading": "تفسیر",
    "emptyText": "اس آیت کے لیے AI سے تیار کردہ تفسیر خلاصہ حاصل کریں۔",
    "generate": "تفسیر تیار کریں",
    "commentary": "تشریح",
    "regenerate": "دوبارہ تیار کریں",
    "regenerate_aria": "تفسیر دوبارہ تیار کریں",
    "attribution": "AI سے تیار کردہ خلاصہ · مستند علمی رہنمائی کا بدل نہیں",
    "error": "تفسیر تیار نہیں ہو سکی۔",
    "pending": "تشریح پڑھی جا رہی ہے…"
  },
  "related": {
    "heading": "متعلقہ آیات",
    "copied": "کاپی ہو گئی: {{ref}}",
    "failedToCopy": "کاپی نہیں ہو سکی",
    "empty": "کوئی متعلقہ آیت نہیں ملی۔",
    "error": "متعلقہ آیات لوڈ نہیں ہو سکیں۔",
    "pending": "متعلقہ آیات تلاش کی جا رہی ہیں…"
  },
  "favorites": {
    "panel_aria": "پسندیدہ آیات",
    "title": "پسندیدہ آیات",
    "proLocked": "آیات کی پسندیدگی ایک Pro خصوصیت ہے۔",
    "loading": "لوڈ ہو رہا ہے…",
    "failedToLoad": "پسندیدہ لوڈ نہیں ہو سکیں",
    "empty": "ابھی کوئی پسندیدہ نہیں۔ کسی بھی آیت پر دل دبا کر اسے محفوظ کریں۔",
    "reference": "— سورہ {{surah}}، آیت {{ayah}}",
    "remove_aria": "پسندیدہ سے ہٹائیں",
    "failedToRemove": "ہٹایا نہیں جا سکا"
  }
}
